import { render, staticRenderFns } from "./ArticlesPage.vue?vue&type=template&id=bb8f225c&scoped=true&"
import script from "./ArticlesPage.vue?vue&type=script&lang=js&"
export * from "./ArticlesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8f225c",
  null
  
)

export default component.exports